<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-12-12 19:40:01
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-05-13 15:10:24
-->
<template>
	<div class="container">
    <div class="top">
      <img class="logo" src="@/assets/images/spark/logo-text.png" />
      <div class="desc">一款基于AI大模型的行业应用</div>
    </div>
    
    <div class="login-type">
      <span :class="['item',{'act':loginType=='code'}]" @click="loginTypeChange('code')">验证码登录</span>
      <span :class="['item',{'act':loginType=='password'}]" @click="loginTypeChange('password')">密码登录</span>
    </div>
		<CodeLogin v-if="loginType=='code'" @submit="submit"></CodeLogin>
		<PwLogin v-if="loginType=='password'" @submit="submit"></PwLogin>
    <!-- <div class="wechat" @click="wechatLogin()" v-if="$store.state.isWeixinBrowser">
      <van-icon name="chat" />
      微信登录
    </div> -->
    <div class="protocol">
      <van-checkbox class="checkbox" v-model="protocolChecked" checked-color="#7FBE26" icon-size="18px"></van-checkbox>
      我已阅读并同意<span class="xieyi" @click="popShow=true">《法律声明及隐私政策》</span>
    </div>
    <van-popup round v-model="popShow" position="bottom" :style="{ height: '80%' }">
      <Protocol></Protocol>
    </van-popup>
	</div>
</template>
  
  <script>
  import Protocol from "./components/Protocol";
  import PwLogin from "./PwLogin";
	import CodeLogin from "./CodeLogin";
  export default {
		components: {
			PwLogin,
			CodeLogin,
      Protocol
		},
    data() {
      return {
        loginType: "code",
        popShow:false,
        protocolChecked:true,
      }
    },
    created() {
      
			},
  	methods: {
			loginTypeChange(type) {
				this.loginType = type;
			},
      wechatLogin(){
        if(!this.protocolChecked){
          this.$toast("请先同意《法律声明及隐私政策》");
          return false;
        }
        window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx98b2f26983ad5b34&redirect_uri=https://m-ai.nongji360.com/wechat-login&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      },
    /**
     * @description: 手机号方式登录
     * @return {*}
     */    
    submit(params){
      if(!this.protocolChecked){
        this.$toast("请先同意《法律声明及隐私政策》");
        return false;
      }
      this.$store.dispatch("Login",params).then(res => {
				this.$toast("登录成功");
				this.$store.dispatch("GetUserInfo");
				// this.$router.push("/")
			})
    },  
     
    }
  };
  </script>
  
  <style scoped lang="scss">
  .container {
    width: 100%;
		min-height: 100vh;
		box-sizing: border-box;
		padding: 0 23px;
		background: linear-gradient(to bottom,rgba(127,190,38,.25) 0,#ffffff 50%,#ffffff 100%);
    .top{
      padding: 85px 0 30px;
      .logo{
        height: 30px;
        width: auto;
      }
      .desc{
        font-size: 18px;
        color: #616161;
        margin-top: 10px;
      }
    }

		.login-type{
			display: flex;
			align-items: center;
			.item{
				font-size: 17px;
				color: #7A7A7A;
				margin-right: 20px;
				&.act{
					font-size: 19px;
					color: #323333;
					position: relative;
					&:after{
						content: "";
						display: block;
						width: 48px;
						height: 4px;
						background: #7FBE26;
						border-radius: 2px;
						position: absolute;
						left: 50%;
						bottom: -5px;
						transform: translateX(-50%);
					}
				}
			}
		}
   
    .wechat{
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      color: #7FBE26;
      .van-icon{
        margin-right: 3px;
        font-size: 18px;
      }
    }
    .protocol{
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #888888;
      .checkbox{
        margin-right: 4px;
      }
      .xieyi{
        color: #7FBE26;
      }
    }
  }
  </style>
  